import * as React from 'react';
import styled from 'styled-components';
import { animated } from 'react-spring';
import { useQuery } from '@apollo/client';

import { OFFICE_VALUATION_QUERY } from '../../../../client/__graphql__/queries';

import { Section } from '../../layout/Section';
import { Container } from '../../layout/Container';
import { Heading } from '../../ui/text/Heading';
import { Paragraph } from '../../ui/text/Paragraph';

import { AccordionGeneral } from '../../partials/AccordionGeneral';
import { AccordionBenefits } from '../../partials/AccordionBenefits';

import { Thanks } from '../../layout/Thanks';
import { useFormTransition } from '../../../utils/hooks/useFormTransition';
import { useFadeTransition } from '../../../utils/hooks/useFadeTransition';
import { BackgroundLoad } from '../../layout/BackgroundLoad';
import { Seo } from '../../../utils/seo/Index';
import { AboutValuationText } from '../../partials/AboutValuationText';
import { PageType } from '../../../__types__/generated/globalTypes';
import { useLocation, useParams } from 'react-router';
import { ValuationForm } from '../../partials/forms/Valuation';
import { useValuationContext } from '../../../utils/hooks/useValuationContext';

const ValuationOffice: React.FC = () => {
  const params = useParams<{ urltag: string }>();
  const { posted, init } = useValuationContext();

  React.useEffect(() => {
    init({
      pageType: PageType.KONTOR
    });
  }, []);

  const { fadeIn: pageFadeIn } = useFadeTransition({
    immidiate: true
  });
  const { fadeIn, fadeOut } = useFormTransition({
    posted
  });

  const { data } = useQuery(OFFICE_VALUATION_QUERY, {
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        urltag: params.urltag
      }
    }
  });

  return (
    <>
      <Seo
        title="Verdivurdering fra PrivatMegleren"
        description="Som kunde hos PrivatMegleren får du en skreddersydd prosess tilpasset dine behov og ønsker."
        image=""
      />
      <Container style={{ paddingTop: '100px', ...pageFadeIn }}>
        <FormWrapper style={fadeOut}>
          <Section className="form-section" style={{ paddingBottom: '10px' }}>
            {data?.getOffice?.text ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.getOffice?.text
                }}
              />
            ) : (
              <>
                <Heading tag="h1" center={true}>
                  Skal du selge eiendom?
                </Heading>
                <Paragraph center={true} className="form-text">
                  Vurderer du å selge eiendommen din? Lurer du på hva egen
                  eiendom er verdt, hva det koster å selge eiendommen eller hva
                  du bør gjøre før du skal selge? Vi har en klar strategi: å
                  samle de beste meglerne og gi dem de beste verktøyene for å
                  lykkes med ditt eiendomssalg. Vi har enerett på
                  revolusjonerende digital teknologi for å markedsføre
                  eiendommen din. Det tjener du på.
                </Paragraph>
                <Paragraph center={true} className="form-text">
                  Fyll ut skjemaet, så avtaler vi gjerne en tid for å vise
                  hvordan din eiendom kan presenteres gjennom PrivatMegleren.
                </Paragraph>
              </>
            )}
          </Section>
          <ValuationForm />
          <Section className="form-section">
            <AboutValuationText />
          </Section>
          <Section className="form-section">
            <AccordionBenefits />
          </Section>
        </FormWrapper>
        <Thanks style={fadeIn}>
          <Section className="form-section">
            <Heading tag="h1" center={true}>
              Tusen takk
            </Heading>
            <Paragraph center={true}>
              En eiendomsmegler vil ta kontakt med deg innen kort tid for å
              avtale en befaring.
            </Paragraph>
            <Paragraph center={true}>
              I mellomtiden kan du lese mer om salg av eiendom her.
            </Paragraph>
            <AccordionGeneral />
          </Section>
          <Section className="form-section" style={{ paddingTop: 0 }}>
            <AccordionBenefits />
          </Section>
        </Thanks>
      </Container>
      <BackgroundLoad
        opacity={0.3}
        url="https://cdn.reeltime.no/pm_assets/img/cbimage.jpg"
      />
    </>
  );
};

export default ValuationOffice;

const FormWrapper = styled(animated.div)``;
